export var RemoteUriString;
(function (RemoteUriString) {
    function is(value) {
        return value.startsWith('http:') || value.startsWith('https:');
    }
    RemoteUriString.is = is;
})(RemoteUriString || (RemoteUriString = {}));
export var ExternalDownloader;
(function (ExternalDownloader) {
    function mock(options) {
        return new ExternalDownloaderMock(options);
    }
    ExternalDownloader.mock = mock;
})(ExternalDownloader || (ExternalDownloader = {}));
class ExternalDownloaderMock {
    options;
    constructor(options) {
        this.options = options;
    }
    async get(uri) {
        if (!this.options.fixtures[uri]) {
            throw new Error(`404 not found: ${uri}`);
        }
        const fixture = this.options.fixtures[uri];
        if (fixture instanceof Uint8Array) {
            return fixture;
        }
        else if (typeof fixture === 'string') {
            return new TextEncoder().encode(fixture);
        }
        else {
            return new TextEncoder().encode(JSON.stringify(fixture));
        }
    }
}
//# sourceMappingURL=downloader.js.map